<template>
    <section class="p-2">
      <v-card>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">{{ bankName }} - Branch List</div>
          <div>
            <bread-crumb :bread-crumbs="['partnerBranch Summary']" />
          </div>
        </v-card-title>
  
        <v-data-table fixed-header  height="55vh"
          :headers="activeHeaders"
          :items="ActiveBranchSummary"
          :search="Banksearch"
          show-select
          :single-select="singleSelect"
          v-model="selectedItems"
          item-key="name"
        >
          <!-- <template v-slot:item.branch="{ item }">
            <a class="text-decoration-underline" @click="navBranchList(item)">
              {{ item.branch }}
            </a>
          </template> -->
          <template v-slot:item.selected="{ item, select }">
            <v-checkbox
              v-model="selectedItems"
              @change="select"
              :value="item.id"
            ></v-checkbox>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="d-flex">
              <v-btn depressed 
                x-small
                @click="openBlockDialog(item)"
     
                color="success"
                title="Block user"
                class="text-capitalize me-3"
                v-if="item.status"
              >
                Activate
              </v-btn>
              <v-btn depressed 
                x-small
                @click="openBlockDialog(item)"
                color="warning"
                class="text-capitalize me-3"
                title="Unblock user"
                v-else
              >
                Deactivate
              </v-btn>
            </div>
          </template>
  
          <template v-slot:top>
            <v-divider class="p-0 m-0 primary--text"></v-divider>
  
            <div class="d-flex mt-5">
                <v-btn depressed 
                @click="downloadExcelsheet"
                color="primary"
                small
                class="me-3 ml-2"
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
              <v-spacer> </v-spacer>
              <v-spacer> </v-spacer>
              <v-text-field
                v-model="Banksearch"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                class="me-4 mb-5"
                dense
                clearable
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
        <v-data-table fixed-header  height="55vh"
          :headers="dessertHeaders"
          :items="BranchSummary"
          :search="search"
          show-select
          :single-select="singleSelect"
          v-model="selectedItems"
          item-key="name"
        >
          <template v-slot:item.action="{ item }">
            <div class="d-flex">
              <v-btn depressed 
                x-small
                @click="openBlockDialog(item)"
                color="success"
                title="Block user"
                class="text-capitalize me-3"
                v-if="item.status"
              >
                Activate
              </v-btn>
              <v-btn depressed 
                x-small
                @click="openBlockDialog(item)"
                color="warning"
                class="text-capitalize me-3"
                title="Unblock user"
                v-else
              >
                Deactivate
              </v-btn>
            </div>
          </template>
  
          <template v-slot:top>
            <v-divider class="p-0 m-0 primary--text"></v-divider>
  
            <div class="d-flex mt-5">
                <v-btn depressed 
                @click="downloadExcelsheet"
                color="primary"
                small
                class="me-3 ml-2"
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
              <v-spacer> </v-spacer>
              <v-spacer> </v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                class="me-4 mb-5"
                dense
                clearable
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
        <v-dialog persistent v-model="showBlockDialog" width="500">
          <v-card>
            <v-card-title class="border border-bottom"
              >Update Bank Status</v-card-title
            >
            <v-card-text class="h5 py-3"
              >Are you sure you want to {{ title_text }}?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed 
                small
                color="primary"
                outlined
                @click="confirmBlock(isActive ? false : true)"
              >
                {{ title_text }}<v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed 
                small
                color="primary"
                outlined
                @click="showBlockDialog = false"
              >
                Close<v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <OverlayPageVue :showOverlay="loader" />
      </v-card>
    </section>
  </template>
  
  <script>
  import OverlayPageVue from "@/utils/OverlayPage.vue";
  import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
  import alerts from "@/mixins/alerts";
  export default {
    mixins: [alerts],
    name: "partnerBranch Summary",
    data() {
      return {
        search: "",
        Banksearch:"",
        showBlockDialog: false,
        isActive: null,
        blockId: null,
        loader: false,
        bankName:"",
        title_text:"",
        dessertHeaders: [
          {
            text: "Country",
            sortable: false,
            value: "country",
          },
          { text: "Location ID", value: "location_id" },
          { text: "Bank Name", value: "bank_name" },
          { text: "Payment Mode", value: "payment_mode" },
          { text: "Activate", value: "action", sortable: false },
        ],
        activeHeaders: [
          {
            text: "Country",
            sortable: false,
            value: "country",
          },
          { text: "Bank Name", value: "bank_name" },
          { text: "External Bank ID", value: "bank_id" },
          { text: "Branch", value: "branch" },
          { text: "Payment Mode", value: "payment_mode" },
          { text: "Is Primary Agent", value: "is_primary_agent" },
          { text: "Activate", value: "action", sortable: false },
        ],
        BranchSummary: [
          {
            bank_name: "State Bank of India",
            bank_code: "SBI002",
            country: "India",
            payment_mode: "Bank transfer",
            location_id: 12321,
            status: true,
          },
        ],
        ActiveBranchSummary:[
            {
            bank_name: "Agrani Bank",
            bank_code: "AGR002",
            country: "Bangladesh",
            branch: "Branch",
            payment_mode: "Bank transfer",
            no_of_branches: 12,
            status: false,
            bank_id: 122,
            },
            {
            bank_name: "State Bank of India",
            bank_code: "SBI002",
            country: "India",
            payment_mode: "Bank transfer",
            branch: "Branch",
            status: false,
            bank_id: 12224,
            },
        ],
      };
    },
    components: {
      BreadCrumb,
      OverlayPageVue,
    },
    mounted() {
        this.bankName = this.$route.params.bank_name;
        console.log(this.bankName)
    },
    computed: {
     
    },
    methods: {
      async downloadExcelsheet() {
        if (this.BankSummary) {
          this.exportToExcel(
            this.dessertHeaders,
            this.BankSummary,
            "Deactive_Bank_List"
          );
        } else if(this.ActiveBankSummary){
            this.exportToExcel(
            this.activeHeaders,
            this.ActiveBankSummary,
            "Active_Bank_list"
          );
        }
      },
     
      navBranchList(item) {
        this.$router.push({
            name: 'partnerBranch Summary',
            params: item,
          })
      },
      openBlockDialog(item) {
        this.title_text = item.status ? "Activate" : "Deactivate";
        this.showBlockDialog = true;
        this.isActive = item.status;
        this.blockId = item.partner_id;
      },
      confirmBlock(){
        this.showBlockDialog = false;
      }
    },
  };
  </script>
  <style scoped lang="scss">
  @import "@/global.scss";
  .width-anchor {
    width: 200px !important;
  }
  
  .required:after {
    content: " *";
    color: red;
  }
  </style>
  